import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { GenSingleImagePreviewData } from '../../../../../../../models/google-template/preview-interfaces/gen-single-image-preview-data.interface';
import { CreativeFormat, CreativeImageRouterHelper } from '../../../../../../../utils/creative-image-router-helper';
import { MobileFrameComponent } from '../../../preview-common/mobile-frame/mobile-frame.component';
import { YoutubeMobileBottomNavComponent } from '../../../preview-common/youtube/youtube-mobile-bottom-nav/youtube-mobile-bottom-nav.component';
import { YoutubeMobileNavbarComponent } from '../../../preview-common/youtube/youtube-mobile-navbar/youtube-mobile-navbar.component';

@Component({
    selector: 'app-gen-youtube-home-feed-ad-mobile',
    imports: [
        CommonModule,
        MobileFrameComponent,
        YoutubeMobileNavbarComponent,
        YoutubeMobileBottomNavComponent,
    ],
    templateUrl: './youtube-home-feed-ad-mobile.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: [
        '../../../preview-common/youtube/youtube-mobile-styles.scss',
        './youtube-home-feed-ad-mobile.component.scss',
    ]
})
export class YoutubeHomeFeedAdMobilePreviewComponent {
  @Input() data!: GenSingleImagePreviewData;

  /** This placement's creative slot is the 1.91:1 landscape format. */
  readonly creativeFormat: CreativeFormat = 'landscape';

  /** Shown in place of the creative when the matching upload is missing. */
  readonly missingDimensionLabel = CreativeImageRouterHelper.labelFor(this.creativeFormat);

  /** The uploaded creative matching {@link creativeFormat}, if any. */
  get creativeImage(): string {
    return CreativeImageRouterHelper.resolve(this.data.images ?? [], this.creativeFormat);
  }
}
